export default "__VITE_ASSET__CizMoe2k__"